import { GraphQLInternalErrorCode } from './graphqlErrors';

export const CODED_MESSAGE_SEPARATOR = ': ';
const CODE_DELIMITER = ':';

export const FLOW_GENERATION_FAILURE_CODES: ReadonlySet<GraphQLInternalErrorCode> =
  new Set([
    GraphQLInternalErrorCode.FLOW_GENERATION_REFUSED,
    GraphQLInternalErrorCode.FLOW_GENERATION_OUTPUT_TRUNCATED,
    GraphQLInternalErrorCode.FLOW_GENERATION_ENDED_UNEXPECTEDLY,
  ]);

export const FLOW_EXECUTION_BLOCK_CODES: ReadonlySet<GraphQLInternalErrorCode> =
  new Set([GraphQLInternalErrorCode.FLOW_REFERENCES_UNRESOLVED]);

export interface CodedMessage<Code extends string> {
  code: Code;
  message: string;
}

export const formatCodedMessage = (code: string, message: string): string =>
  `${code}${CODED_MESSAGE_SEPARATOR}${message}`;

export const parseCodedMessage = <Code extends string>(
  text: string | null | undefined,
  codes: ReadonlySet<Code>,
): CodedMessage<Code> | null => {
  if (!text) {
    return null;
  }
  const found = text.indexOf(CODE_DELIMITER);
  const separatorIndex = found < 0 ? text.length : found;
  const code = text.slice(0, separatorIndex).trim();
  return codes.has(code as Code)
    ? {
        code: code as Code,
        message: text.slice(separatorIndex + CODE_DELIMITER.length).trim(),
      }
    : null;
};

export const parseFlowGenerationFailureCode = (
  text: string | null | undefined,
): GraphQLInternalErrorCode | null =>
  parseCodedMessage(text, FLOW_GENERATION_FAILURE_CODES)?.code ?? null;
